import React from "react";
import { Button, Flex, Alert } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";

export default function AppointmentEmptyProvider() {
  const navigate = useNavigate();
  return (
    <Flex direction="column" gap={12} margin={21}>
      <Alert
        variation="warning"
        isDismissible={false}
        hasIcon={true}
        heading="Attention!"
      >
        You need to add a health care provider in order to record an
        appointment. Click the button below to add it now.
      </Alert>
      <Flex>
        <Button
          onClick={() =>
            navigate(
              "/user/hr/health-providers/add?fromURL=/user/quick-actions/appointment-reminder/add"
            )
          }
        >
          Add a health care provider
        </Button>
      </Flex>
    </Flex>
  );
}
